import config from "@/config";
import { isNotEmpty } from "@/core/string";

import { getExternalApi, requestConfig } from "./apiRoot";

export interface GeocoderRequest extends google.maps.GeocoderRequest {
    key: string;
}

export const getLocalitiesSuggestions = async (zipCode?: string, country?: string): Promise<string[]> => {
    if (isNotEmpty(zipCode)) {
        const axiosRequestConfig = requestConfig<GeocoderRequest>({
            params: {
                address: zipCode + "," + country,
                key: config.MAPS_API_KEY,
            },
        });
        const { data } = await getExternalApi().get<google.maps.GeocoderResponse>(
            "https://maps.googleapis.com/maps/api/geocode/json",
            axiosRequestConfig,
        );

        return [...data.results.map((result) => result.postcode_localities || []).flat()];
    }
    return Promise.resolve([]);
};
